const PRODUCT_TYPE = {
  HOME_REFI: 'Imóvel em garantia',
  HOME_FIN: 'Financiamento de imóvel',
  AUTO_REFI: 'Veículo em garantia',
}

const PRODUCT_TYPE_DESCRIPTION = {
  AUTO_REFI: 'Empréstimo com garantia de veículo',
  HOME_REFI: 'Empréstimo com garantia de imóvel',
}

const PRODUCTS = {
  AUTO: 'AUTO_REFI',
  HOME: 'HOME_REFI',
  HOME_FIN: 'HOME_FIN',
}

const STORAGE_PRODUCTS = {
  AUTO_REFINANCING: 'AUTO_REFINANCING',
  HOME_REFINANCING: 'HOME_REFINANCING',
  HOME_FINANCING: PRODUCTS.HOME_FIN,
}

export { PRODUCT_TYPE, PRODUCT_TYPE_DESCRIPTION, PRODUCTS, STORAGE_PRODUCTS }
